import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "./cn";

export type PillVariant = "default" | "outline" | "brand" | "cta";
export type PillSize = "sm" | "md";

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: PillVariant;
  size?: PillSize;
}

const VARIANTS: Record<PillVariant, string> = {
  default: "bg-surface-muted text-ink",
  outline: "bg-transparent border border-border text-ink",
  brand: "bg-brand-soft text-brand-fill",
  cta: "bg-cta-soft text-cta",
};

const SIZES: Record<PillSize, string> = {
  sm: "text-caption px-2 py-0.5",
  md: "text-button-sm px-3 py-1",
};

export const Pill = forwardRef<HTMLSpanElement, PillProps>(
  ({ className, variant = "default", size = "md", ...props }, ref) => (
    <span
      ref={ref}
      className={cn(
        "inline-flex items-center gap-1 rounded-pill font-medium",
        VARIANTS[variant],
        SIZES[size],
        className,
      )}
      {...props}
    />
  ),
);
Pill.displayName = "Pill";
